/*
  reducer for AUTHORIZATION with DE backend.

  maintains state for the logged in user.
*/
import jwt from 'jsonwebtoken';
import * as types from '../../app/employer/redux/constants';
import {localStorageKey} from "../../constants";

const defaultLoggedInUser = {
   organizationId: null,
   fname: '',
   lname: '',
   username: '',
   roles: [],
   organizations: [],
   impersonating: false,
};

const defaultLoggedInUserPartner = {
   organizationId: null,
   impersonating: false,
   email: undefined,
   roles: [],
};

const initialState = {
   loggedInUser: { ...defaultLoggedInUser },
   loggedInUserPartner: { ...defaultLoggedInUserPartner },
   isLoggedIn: false,
   isLoggedInPartner: false,
   // set when the partner credential is rejected (401) so the global banner can
   // tell the user to sign in again; cleared on the next partner login
   partnerSessionExpired: false,
   loginPending: false,
   loginError: '',
   userDetailError: '',
   global: {
      isLoading: true,
      loadingError: '',
      loadingSuccess: '',
   },
};

export default function reducer(state = initialState, action) {
   switch (action.type) {
      case types.AUTH_COMPONENT_LOGIN_USER_PENDING:
         return {
            ...state,
            loginPending: true,
            loginError: '',
         };
      case types.AUTH_COMPONENT_LOGIN_USER_SUCCESS:
         localStorage.setItem(localStorageKey.employerToken, action.payload.token);
         return {
            ...state,
            isLoggedIn: true,
            loginPending: false,
            loginError: '',
         };
      case types.AUTH_COMPONENT_LOGIN_USER_ERROR:
         return {
            ...state,
            isLoggedIn: false,
            loginPending: false,
            loginError: action.payload.error,
         };
      case types.AUTH_COMPONENT_LOGOUT_USER_SUCCESS:
         localStorage.removeItem(localStorageKey.employerToken);
         localStorage.removeItem(localStorageKey.partnerToken);
         localStorage.removeItem(localStorageKey.jobcaseToken);
         localStorage.removeItem(localStorageKey.jobcaseRefreshToken);
         return {
            ...state,
            loginPending: false,
            loggedInUser: { ...defaultLoggedInUser },
            loggedInUserPartner: { ...defaultLoggedInUserPartner },
            isLoggedInPartner: false,
            isLoggedIn: false,
         };
      case types.AUTH_COMPONENT_GET_USER_DETAILS_SUCCESS:
         return {
            ...state,
            loggedInUser: action.payload.user,
            ...{ global: { isLoading: false } },
            userDetailError: '',
            isLoggedIn: true,
         };
      case types.AUTH_COMPONENT_GET_USER_DETAILS_ERROR:
         localStorage.removeItem(localStorageKey.employerToken);
         return {
            ...state,
            loggedInUser: { ...defaultLoggedInUser },
            userDetailError: action.payload.error,
         };
      case types.GLOBAL_COMPONENT_GET_USER_DETAILS_LOADING:
         return {
            ...state,
            global: {
               ...state.global,
               isLoading: true,
               loadingSuccess: '',
               loadingError: '',
            },
         };
      case types.GLOBAL_COMPONENT_GET_USER_DETAILS_ERROR:
         return {
            ...state,
            global: {
               ...state.global,
               isLoading: false,
               loadingSuccess: '',
               loadingError: action.payload.message || 'true',
            },
         };
      case types.AUTH_COMPONENT_UPDATE_USER_NAME:
         return {
            ...state,
            loggedInUser: {
               ...state.loggedInUser,
               fname: action.payload.fname,
               lname: action.payload.lname,
            },
         };
      case types.AUTH_COMPONENT_UPDATE_USER_PHONE:
         return {
            ...state,
            loggedInUser: {
               ...state.loggedInUser,
               phone: action.payload.phone,
            },
         };
      case types.AUTH_COMPONENT_UPDATE_USER_EMAIL:
         return {
            ...state,
            loggedInUser: {
               ...state.loggedInUser,
               email: action.payload.email,
            },
         };
      case types.AUTH_COMPONENT_PARTNER_SESSION_EXPIRED:
         // Only the partner session dies: drop the rejected token so requests stop
         // carrying it, but leave the DE and gateway sessions (and their tokens) alone.
         localStorage.removeItem(localStorageKey.partnerToken);
         return {
            ...state,
            isLoggedInPartner: false,
            partnerSessionExpired: true,
            loggedInUserPartner: { ...defaultLoggedInUserPartner },
         };
      case types.AUTH_COMPONENT_LOGIN_USER_SUCCESS_PARTNER:
         localStorage.setItem(localStorageKey.partnerToken, action.payload.token);
         const decoded = jwt.decode(action?.payload?.token);
         const {
            sub,
            organization,
            auth = [],
            impersonated = false,
            fname,
            lname,
         } = decoded;

         return ({
            ...state,
            isLoggedInPartner: true,
            partnerSessionExpired: false,
            loggedInUserPartner: {
               email: sub,
               organizationId: organization,
               impersonating: impersonated,
               roles: auth,
               fname,
               lname,
            },
         });
      case types.AUTH_COMPONENT_INIT_LOGIN_USER_PARTNER_DETAILS:
         const tokenPartner = localStorage.getItem(localStorageKey.partnerToken);
         const isLoggedInPartner = tokenPartner !== null;

         let loggedInUserPartner = state.loggedInUserPartner;

         if (isLoggedInPartner) {
            const decoded = jwt.decode(tokenPartner);
            const {
               sub,
               organization,
               auth = [],
               impersonated = false,
            } = decoded;

            loggedInUserPartner = {
               ...loggedInUserPartner,
               email: sub,
               organizationId: organization,
               impersonating: impersonated,
               roles: auth,
            };

         }

         return ({
            ...state,
            isLoggedInPartner: isLoggedInPartner,
            loggedInUserPartner: loggedInUserPartner,
         });

      case types.AUTH_GLOBAL_SET_ISLOADING:
         return ({
            ...state,
            global: {
               ...state.global,
               isLoading: action.payload.isLoading,
            },
         });
      default:
         return state;
   }
}
